import {
  Box,
  Container,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  Text,
  List,
  VStack,
  useUpdateEffect,
  useToast,
  CircularProgress,
  Checkbox,
  Grid,
  Tag,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import { ReactComponent as EmptyTransactionState } from "assets/svg/empty-inpl.svg";

import { useParams } from "react-router-dom";
// import WalletTransfer from "components/WalletTransfer/WalletTransfer";
// import { useCallback, useMemo, useState } from "react";
import Button from "components/Button/Button";
// import { NumberInputWithMax } from "components/Input/NumberInput";
// import toPrecision from "util/toPrecision";

// import { ReactComponent as AddCircleIcon } from "assets/svg/add-circle.svg";
import toCoinLocale from "util/toCoinLocale";
// import StakeInfo from "components/StakeInfo/StakeInfo";
// import toPrecision from "util/toPrecision";
// import Select from "components/Select/Select";
import DetailItem from "components/DetailItem/DetailItem";
import Confirmation from "components/Modals/p2p/Confirmation";
import {
  useGetStakingByIdQuery,
  useUpdateSubscriptionMutation,
} from "services/walletApi";
import { useCallback, useMemo, useState } from "react";
import { capitalize, toLower } from "lodash";
import toPrecision from "util/toPrecision";
import getError from "util/getError";
import SuccessModal from "components/Modals/Success";
import { useHistory } from "react-router-dom";

import {
  addDays,
  differenceInDays,
  parseISO,
  format,
  formatDistanceToNow,
  isPast,
} from "date-fns";

export default function CoinEarnings(props) {
  const currentPage = "Earn";

  const toast = useToast();
  const history = useHistory();

  // const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState({
    modalFor: "none",
    isOpen: false,
    isChecked: false,
  });

  const isOpen = useCallback(
    (modalFor) => modal.modalFor === modalFor && modal.isOpen,
    [modal]
  );
  const onOpen = useCallback(
    (modalFor) => () => {
      setModal({ modalFor, isOpen: true });
    },
    []
  );

  const onClose = useCallback(
    (modalFor) => () => {
      setModal({ modalFor, isOpen: false });
    },
    []
  );

  const { coin, id } = useParams();

  console.log("Stake ID", id);
  console.log("Modal state", modal);
  //   const history = useHistory();

  const { data, isLoading } = useGetStakingByIdQuery(id);

  const [_udpateSub, { isLoading: isUpdating, isError, error, isSuccess }] =
    useUpdateSubscriptionMutation();

  const stake = useMemo(() => data?.stake, [data]);

  const createdDate = useMemo(
    () =>
      stake?.createdAt &&
      stake?.product?.tenor &&
      addDays(parseISO(stake?.createdAt), stake?.product?.tenor ?? 0),
    [stake]
  );

  const redeemDate = useMemo(
    () =>
      !stake?.product?.expiresOn
        ? createdDate
        : parseISO(stake?.product?.expiresOn),
    [stake, createdDate]
  );

  const isExpired = useMemo(() => isPast(redeemDate), [redeemDate]);

  console.log("REDEEMED", redeemDate, stake?.createdAt, stake?.product?.tenor);

  // const redeemDate = useMemo(() => sub(new Date(), { hours: 23 }), []);

  const daysLeft = useMemo(
    () => (redeemDate && differenceInDays(redeemDate, new Date())) ?? 0,
    [redeemDate]
  );

  const hoursMinsLeft = useMemo(
    () => redeemDate && formatDistanceToNow(redeemDate),
    [redeemDate]
  );

  // const hoursMinsLeft = "3 hrs";

  console.log(
    "HOURS AND MINS LEFT",
    hoursMinsLeft,
    stake?.product?.tenor && +daysLeft <= 0
  );

  const accuringInterest = useMemo(
    () =>
      (+stake?.product?.originalApr * (+stake?.product?.tenor - daysLeft)) /
      365,
    [stake, daysLeft]
  );

  const fee = useMemo(() => {
    if (stake?.product?.fee?.applicable === "rate") {
      return +accuringInterest * (+stake?.product?.fee?.rate / 100);
    }
    if (stake?.product?.fee?.applicable === "fixed") {
      return +stake?.product?.fee?.fixed;
    }

    return 0;
  }, [accuringInterest, stake?.product?.fee]);

  const reward = useMemo(
    () => +stake?.value?.$numberDecimal + +accuringInterest - +fee,
    [stake, accuringInterest, fee]
  );

  const hasType = useMemo(
    () => ["fixed", "flexible"].includes(toLower(stake?.product?.type)),
    [stake]
  );

  // const totalAmount = useMemo(
  //   () => +stake?.value?.$numberDecimal + accuringInterest,
  //   [stake, accuringInterest]
  // );

  // console.log("DAYS LEFT", daysLeft, redeemDate, totalAmount);

  // console.log({ modal });

  console.log("Reward", reward);

  // const isRedeemable = useMemo(() => stake?.status === 'active' && isAfter((addDays(parseISO(stake?.createdAt, stake?.product?.tenor)), new Date()), [])

  console.log("STAKE INFO", stake);

  const redeemSubscription = () => {
    onClose("confirm:redeem")();
    const reqData = { operation: "redeem" };
    _udpateSub({ id, ...reqData });
  };

  const rolloverSubscription = () => {
    onClose("confirm:rollover")();
    const reqData = { operation: "rollover" };
    _udpateSub({ id, ...reqData });
  };

  const terminateSubscription = () => {
    onClose("confirm:terminate")();
    const reqData = { operation: "cancel" };
    _udpateSub({ id, ...reqData });
  };

  const handleSuccessClose = (modalFor) => {
    onClose(modalFor)();
    setModal({ modalFor, isOpen: false });
    history.push(`/dashboard/earn/earnings/${coin}`);
  };

  useUpdateEffect(() => {
    if (isSuccess && !isOpen(modal.modalFor)) {
      // onClose("confirm:redeem");
      console.log({ isSuccess, modal });
      modal.modalFor === "confirm:redeem" && onOpen("success:redeem")();
      modal.modalFor === "confirm:terminate" && onOpen("success:terminate")();
      modal.modalFor === "confirm:rollover" && onOpen("success:rollover")();
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, isError, toast, onClose, onOpen, modal, isOpen]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 35vw)", "calc(100% - 50vw)"]}
            m="0"
            // p="0"
          >
            <Box px={["0", "0", "0"]}>
              <Heading fontSize="3xl">
                {toCoinLocale(coin)} Earning Details
              </Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/earn/staking?coin=${coin}`}>
                    Earn
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/earn/earnings/${coin}`}>
                    {toCoinLocale(coin)} Earnings
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Details
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            {/* <HStack justifyContent="flex-end" mb="18px">
              <Button
                // disabled={!isEligible}
                variant="ghost"
                bg="transparent"
                size="sm"
                color="#03A438"
                onClick={() => {
                  history.push(`/dashboard/earn/subscribe?coin=${coin}`);
                }}
              >
                <HStack>
                  <Box as={AddCircleIcon} />
                  <Text>Subscribe</Text>
                </HStack>
              </Button>
            </HStack> */}

            {stake && !isLoading && (
              <Box
                bg="white"
                mt="20px"
                pos="relative"
                p={["24px", "56px"]}
                borderRadius={[0, "16px"]}
                border="1px solid #EFF0F7"
                shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
              >
                {stake?.status === "rolledover" && (
                  <Tag
                    size="md"
                    variant="solid"
                    colorScheme="green"
                    textTransform="capitalize"
                    pos="absolute"
                    right="56px"
                    top="20px"
                  >
                    {stake?.status}
                  </Tag>
                )}

                <List>
                  <DetailItem
                    isLoading={isLoading}
                    itemTitle="Coin Type"
                    value={toCoinLocale(coin)}
                  />
                  {+stake?.product?.originalApr && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Annual Percentage"
                      value={`${Number(
                        (+stake?.product?.originalApr ?? 0) * 100
                      ).toFixed(2)}%`}
                    />
                  )}
                  <DetailItem
                    isLoading={isLoading}
                    itemTitle="Principal"
                    value={toPrecision(stake?.value?.$numberDecimal, coin)}
                  />
                  {/* <DetailItem
                  isLoading={isLoading}
                  itemTitle="Countdown"
                  value={"Ongoing"}
                /> */}
                  {stake?.currentStatus && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Status "
                      value={capitalize(stake?.currentStatus ?? "")}
                    />
                  )}
                  {accuringInterest && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Accruing interest "
                      value={toPrecision(
                        accuringInterest,
                        stake?.unit,
                        true,
                        6,
                        true
                      )}
                    />
                  )}
                  {/* {totalAmount && (
                  <DetailItem
                    isLoading={isLoading}
                    itemTitle="Accured Earning "
                    value={toPrecision(totalAmount, stake?.unit, true, 6, true)}
                  />
                )} */}

                  {hasType && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Subscription type"
                      value={stake?.product?.type}
                    />
                  )}

                  {stake?.product?.tenor && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Duration"
                      value={`${stake?.product?.tenor} day${
                        +daysLeft > 1 ? "s" : ""
                      }`}
                    />
                  )}
                  {stake?.product?.tenor && +daysLeft > 0 && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Days Left"
                      value={`${daysLeft} day${+daysLeft > 1 ? "s" : ""}`}
                    />
                  )}
                  {!isExpired && stake?.product?.tenor && +daysLeft === 0 && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Days Left"
                      value={`${hoursMinsLeft}`}
                    />
                  )}

                  {isExpired && (
                    <DetailItem
                      isLoading={isLoading}
                      itemTitle="Expired On"
                      value={`${format(redeemDate, "eee dd, MMM yyyy")}`}
                    />
                  )}
                  <DetailItem
                    isLoading={isLoading}
                    itemTitle="Automatic Rollover"
                    value={stake?.product?.autoRenew ? "Yes" : "No"}
                  />
                  <DetailItem
                    isLoading={isLoading}
                    itemTitle="Reward"
                    value={toPrecision(
                      isNaN(reward) ? 0 : reward,
                      stake?.unit,
                      true,
                      6,
                      true
                    )}
                  />
                  <DetailItem
                    isLoading={isLoading}
                    itemTitle="Fee"
                    value={toPrecision(
                      isNaN(fee) ? 0 : fee,
                      stake?.unit,
                      true,
                      8,
                      true
                    )}
                  />
                </List>

                <VStack py="40px">
                  <Grid
                    templateColumns="repeat(2, 1fr)"
                    w="100%"
                    gap="16px"
                    alignItems="center"
                  >
                    {stake?.currentStatus === "active" && isExpired && (
                      <Button
                        bg="transparent"
                        border="1px solid transparent"
                        borderColor="#ED2E7E"
                        color="#ED2E7E"
                        // minW="280px"
                        minW="100%"
                        h="64px"
                        _focus={{ shadow: "0 0 0 3px #ED2E7E4f" }}
                        _hover={{ shadow: "0 0 0 3px #ED2E7E4f" }}
                        _active={{ shadow: "0 0 0 3px #ED2E7E4f" }}
                        onClick={onOpen("confirm:redeem")}
                        isLoading={
                          modal.modalFor === "confirm:redeem" && isUpdating
                        }
                        disabled={isUpdating}
                      >
                        Redeem
                      </Button>
                    )}

                    {stake?.currentStatus === "active" && isExpired && (
                      <Button
                        bg="transparent"
                        border="1px solid transparent"
                        borderColor="var(--primary)"
                        color="var(--primary)"
                        minW="100%"
                        h="64px"
                        _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                        _hover={{ shadow: "0 0 0 3px var(--focusColor)" }}
                        _active={{ shadow: "0 0 0 3px var(--focusColor)" }}
                        onClick={onOpen("confirm:rollover")}
                        isLoading={
                          modal.modalFor === "confirm:rollover" && isUpdating
                        }
                        disabled={isUpdating}
                      >
                        Rollover
                      </Button>
                    )}
                  </Grid>

                  {stake?.currentStatus === "active" && !isExpired && (
                    <Button
                      bg="transparent"
                      border="1px solid transparent"
                      borderColor="#ED2E7E"
                      color="#ED2E7E"
                      minW="280px"
                      h="64px"
                      _focus={{ shadow: "0 0 0 3px #ED2E7E4f" }}
                      _hover={{ shadow: "0 0 0 3px #ED2E7E4f" }}
                      _active={{ shadow: "0 0 0 3px #ED2E7E4f" }}
                      onClick={onOpen("confirm:terminate")}
                      isLoading={
                        modal.modalFor === "confirm:terminate" && isUpdating
                      }
                      disabled={isUpdating}
                    >
                      Terminate
                    </Button>
                  )}
                </VStack>
              </Box>
            )}

            {!stake && !isLoading && (
              <VStack py="140px">
                <Box as={EmptyTransactionState} />

                <Text color="gray.500">Subscription not found</Text>
              </VStack>
            )}

            {isLoading && (
              <VStack py="100px">
                <CircularProgress
                  isIndeterminate
                  size="18px"
                  color="var(--primary)"
                />
              </VStack>
            )}
          </Container>
        </Box>

        <Confirmation
          title="Redeem"
          isOpen={isOpen("confirm:redeem")}
          onClose={onClose("confirm:redeem")}
          onConfirm={redeemSubscription}
          confirmDisabled={!isExpired && !modal.isChecked}
        >
          {!isExpired && (
            <Text>
              Redeeming this subscription before its end date means that you
              lose the interest accrued on it.
            </Text>
          )}

          {isExpired && (
            <Text>Are you sure you want to redeem this subscription?</Text>
          )}

          {!isExpired && (
            <Checkbox
              mt="40px"
              isChecked={modal.isChecked}
              onChange={(e) =>
                setModal({ ...modal, isChecked: e.target.checked })
              }
              colorScheme="green"
              alignItems="flex-start"
              sx={{
                ".chakra-checkbox__control": {
                  mt: "6px",
                  _focus: { shadow: "0 0 0 3px var(--focusColor)" },
                },
                ".chakra-checkbox__label": {
                  fontSize: "sm",
                  color: "gray.500",
                },
              }}
            >
              I am aware of the redemption rules and confirm my early
              redemption.
            </Checkbox>
          )}
        </Confirmation>

        <Confirmation
          title="Terminate"
          isOpen={isOpen("confirm:terminate")}
          onClose={onClose("confirm:terminate")}
          onConfirm={terminateSubscription}
        >
          <Text>
            Terminating this subscription before its end date means that you
            lose the interest accrued on it.
          </Text>
        </Confirmation>

        <Confirmation
          title="Rollover"
          isOpen={isOpen("confirm:rollover")}
          onClose={onClose("confirm:rollover")}
          onConfirm={rolloverSubscription}
        >
          <Text>Are you sure you want to rollover this subscription?</Text>
        </Confirmation>

        <SuccessModal
          title="Success"
          isOpen={isOpen("success:redeem")}
          message={`Subscription redeemed successfully`}
          onClose={() => handleSuccessClose("success:redeem")}
        />

        <SuccessModal
          title="Success"
          isOpen={isOpen("success:redeem")}
          message={`Subscription rolledover successfully`}
          onClose={() => handleSuccessClose("success:rollover")}
        />

        <SuccessModal
          title="Success"
          isOpen={isOpen("success:terminate")}
          message={`Subscription terminated successfully`}
          onClose={() => handleSuccessClose("success:terminate")}
        />
      </Box>
    </Box>
  );
}
